import { useEffect } from 'react';
import { AUTH_MODAL_EVENT } from '../utils/authPrompt';

const useAuthModalEvent = (onOpenAuth) => {
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;

    const handler = () => {
      if (typeof onOpenAuth === 'function') {
        onOpenAuth();
      }
    };

    window.addEventListener(AUTH_MODAL_EVENT, handler);
    return () => window.removeEventListener(AUTH_MODAL_EVENT, handler);
  }, [onOpenAuth]);
};

export default useAuthModalEvent;